var nativeUndefined = void 0;
var stringUndefined = 'undefined';
var stringObject = 'object';
var objectProto = Object.prototype;
var objectProtoToString = objectProto.toString;
var objectProtoHasOwnProperty = objectProto.hasOwnProperty;
var objectProtoPropertyIsEnumerable = objectProto.propertyIsEnumerable;
var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols;
var objectGetPrototypeOf = Object.getPrototypeOf;
var objectKeys = Object.keys;
var functionProto = Function.prototype;
var functionProtoToString = functionProto.toString;
var symbolExisted = typeof Symbol !== stringUndefined;
var symbolProto = symbolExisted ? Symbol.prototype : nativeUndefined;
var arrayProto = Array.prototype;
var arrayProtoSlice = arrayProto.slice;
var mathMin = Math.min;
var mathMax = Math.max;
var mathRandom = Math.random;
var mathFloor = Math.floor;
var mathCeil = Math.ceil;
var mathAbs = Math.abs;
var numberIsFinite = Number.isFinite;
var numberIsInteger = Number.isInteger;
var numberIsSafeInteger = Number.isSafeInteger;
var globalThisExisted = typeof globalThis === stringObject && globalThis;
var globalExisted = typeof global === stringObject && global;
var selfExisted = typeof self === stringObject && self;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
var MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_ARRAY_LENGTH = 4294967295;
var tagPrefix = '[object ';
var bigIntTag = tagPrefix + 'BigInt]';
var numberTag = tagPrefix + 'Number]';
var booleanTag = tagPrefix + 'Boolean]';
var stringTag = tagPrefix + 'String]';
var dateTag = tagPrefix + 'Date]';
var regExpTag = tagPrefix + 'RegExp]';
var symbolTag = tagPrefix + 'Symbol]';
var errorTag = tagPrefix + 'Error]';
var arrayBufferTag = tagPrefix + 'ArrayBuffer]';
var argumentsTag = tagPrefix + 'Arguments]';
var arrayTag = tagPrefix + 'Array]';
var functionTags = ['Function', 'AsyncFunction', 'GeneratorFunction', 'Proxy'].map(function (item) { return tagPrefix + item + ']'; });
var weakSetTag = tagPrefix + 'WeakSet]';
var blobTag = tagPrefix + 'Blob]';
var fileTag = tagPrefix + 'File]';
var domExceptionTag = tagPrefix + 'DOMException]';
var objectTag = tagPrefix + 'Object]';
var dataViewTag = tagPrefix + 'DataView]';
var mapTag = tagPrefix + 'Map]';
var promiseTag = tagPrefix + 'Promise]';
var setTag = tagPrefix + 'Set]';
var weakMapTag = tagPrefix + 'WeakMap]';
var windowTag = tagPrefix + 'Window]';

export { MAX_ARRAY_LENGTH, MAX_SAFE_INTEGER, MIN_SAFE_INTEGER, argumentsTag, arrayBufferTag, arrayProto, arrayProtoSlice, arrayTag, bigIntTag, blobTag, booleanTag, dataViewTag, dateTag, domExceptionTag, errorTag, fileTag, functionProto, functionProtoToString, functionTags, globalExisted, globalThisExisted, mapTag, mathAbs, mathCeil, mathFloor, mathMax, mathMin, mathRandom, nativeUndefined, numberIsFinite, numberIsInteger, numberIsSafeInteger, numberTag, objectGetOwnPropertySymbols, objectGetPrototypeOf, objectKeys, objectProto, objectProtoHasOwnProperty, objectProtoPropertyIsEnumerable, objectProtoToString, objectTag, promiseTag, regExpTag, selfExisted, setTag, stringObject, stringTag, stringUndefined, symbolProto, symbolTag, weakMapTag, weakSetTag, windowTag };
